import View from './view';
import {useSelector} from 'react-redux';
import {contentSelector} from '../../../redux/selectors/resources';
import {votesListSelector} from '../../../redux/selectors/polls';
import {usePartialList} from '../../../shared/hooks/usePartialList';
import {PollStatus} from '../../../shared/models/poll';
import {useMemo} from 'react';

export const PollsTypeVoteScreen = () => {
  const content = useSelector(contentSelector());
  const polls = useSelector(votesListSelector());
  const isLoading = !polls;

  const completedVotes =
    useMemo(() => polls?.filter((item) => item.statusId === PollStatus.Completed), [polls]) || null;
  const notCompletedVotes =
    useMemo(() => polls?.filter((item) => item.statusId !== PollStatus.Completed), [polls]) || null;

  const [completedItemsToShow, showMoreCompleted, allCompletedShown] = usePartialList(completedVotes);

  const [notCompletedItemsToShow, showMoreNotCompleted, allNotCompletedShown] = usePartialList(notCompletedVotes);

  return View({
    content,
    isLoading,
    pollGroups: [
      {
        showLoadMore: !allNotCompletedShown,
        polls: notCompletedItemsToShow,
        title: 'Текущие голосования',
        onLoadMore: showMoreNotCompleted,
        noItemsText: content.polls.noActiveVotes,
      },
      {
        showLoadMore: !allCompletedShown,
        polls: completedItemsToShow,
        title: 'Завершенные голосования',
        onLoadMore: showMoreCompleted,
        noItemsText: content.polls.noCompletedVotes,
      },
    ],
  });
};
